import React from 'react';
import { OnboardingNav } from '../../components/Onboarding/OnboardingNav';
import { SurveyButton } from '../../components/Survey/SurveyButton';
import { SurveyContainer } from '../../components/Survey/SurveyContainer';
import { SurveyWrapper } from '../../components/Survey/SurveyWrapper';

interface ProgramErrorStateProps {
  errorMessage: string | null;
  onRetry: () => void;
  onStartOver: () => void;
}

export const ProgramErrorState: React.FC<ProgramErrorStateProps> = ({
  errorMessage,
  onRetry,
  onStartOver,
}) => {
  return (
    <div className="onboarding-flow">
      <div className="onboarding-complete onboarding-survey-container">
        <SurveyContainer>
          <SurveyWrapper>
            <OnboardingNav onClick={onStartOver} />
            <div className="survey-program-preview-container">
              <div className="survey-program-header">
                <span className="survey-program-recommendation">Error Loading Program</span>
              </div>
              <div className="survey-error-content">
                <p className="survey-error-message">{errorMessage}</p>
                <div className="survey-program-btn-container" style={{ justifyContent: 'center' }}>
                  <SurveyButton className="survey-primary-btn" onClick={onRetry}>
                    Retry
                  </SurveyButton>
                </div>
              </div>
            </div>
          </SurveyWrapper>
        </SurveyContainer>
      </div>
    </div>
  );
};
